import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

const settingsCardSlotRecipe = defineSlotRecipe({
  className: 'settings-card',
  slots: [
    'root',
    'content',
    'contentBody',
    'contentActions',
    'footer',
    'status',
    'statusIcon',
    'statusLabel',
    'statusMessage',
    'statusMessageText',
    'statusHelperText',
  ],
  base: {
    content: {
      alignItems: 'center',
      display: 'flex',
      gap: '12',
    },
    contentBody: {
      flex: 1,
      minWidth: 0,
    },
    contentActions: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      gap: '8',
    },
    footer: {
      alignItems: 'center',
      display: 'flex',
      gap: '12',
      justifyContent: 'space-between',
      // The switch footer is drawn on a wider gap than the status one.
      '&:has([data-scope="switch"][data-part="root"])': {
        gap: '16',
      },
      // A status message wraps to more than one line: the design gives that footer a deeper bottom
      // padding than the single-line one the Card recipe sets, and keeps the trailing action level
      // with the status row rather than centred against the whole block.
      '&:has([data-slot="status-message"])': {
        alignItems: 'flex-start',
        paddingBlockEnd: '12',
      },
    },
    status: {
      // Not `center`: the icon lines up with the first line of the label, which is where it still
      // belongs once the label wraps.
      alignItems: 'flex-start',
      display: 'flex',
      gap: '4',
      minWidth: 0,
      paddingBlock: '2',
    },
    statusIcon: {
      flexShrink: 0,
      marginBlockStart: '2',
    },
    statusLabel: {
      color: 'text/body',
      textStyle: 'body/md/regular',
      wordBreak: 'break-word',
    },
    statusMessage: {
      minWidth: 0,
    },
    statusMessageText: {
      color: 'text/body',
      paddingInlineStart: '20',
      textStyle: 'body/sm/regular',
      wordBreak: 'break-word',
    },
    statusHelperText: {
      color: 'text/helper',
      marginBlockStart: '8',
      paddingInlineStart: '20',
      textStyle: 'body/sm/regular',
      wordBreak: 'break-word',
    },
  },
  variants: {
    status: {
      error: {
        statusIcon: { color: 'icon/negative' },
        statusLabel: { color: 'text/negative' },
      },
      failed: {
        statusIcon: { color: 'icon/negative' },
      },
      'in-progress': {
        statusIcon: { color: 'icon/warning' },
      },
      neutral: {
        statusIcon: { color: 'icon/secondary' },
      },
      success: {
        statusIcon: { color: 'icon/positive' },
      },
      // No colour on purpose: IconWarningYellow carries its own fixed colours, and CLAUDE.md says a
      // fixed-colour icon is never recoloured. Setting one here would only reach an icon swapped in
      // via `icon`, and would put a second yellow on the same status.
      warning: {},
    },
  },
  defaultVariants: {
    status: 'neutral',
  },
});

export default settingsCardSlotRecipe;
